import { Headline3, Meta, RedBeacon, theme } from 'aimo-ui';
import Icon from 'components/icons/Icon';
import React from 'react';
import styled from 'styled-components/native';
import { isWeb } from 'utils/deviceUtils';
import { testIdentifiers } from 'utils/testIdentifiers';

type ChipCardItemTypes = {
  title: string;
  subTitle?: string;
  label?: string;
  backgroundColor?: string;
  LeftComponent?: React.FC;
  onPress: () => void;
  testID?: string;
  isWaitingAction?: boolean;
  showExternalLinkIcon?: boolean;
  additionalTitle?: string;
};

const CARD_HEIGHT = 90;

const ChipCardContainer = styled.TouchableOpacity<{ backgroundColor?: string }>`
  background-color: ${(props) => props.backgroundColor || theme.colors.white};
  border-radius: 20px;
  margin-right: 20px;
  height: ${CARD_HEIGHT}px;
  ${!isWeb && `max-width: ${theme.normalising.widthPixel(330)}px;`}
  margin-top: 9px;
  justify-content: center;
  border: 2px solid ${theme.colors.gray100};
`;

const Row = styled.View`
  flex-direction: row;
  justify-content: flex-start;
  margin: 20px;
  margin-right: 60px;
  align-items: center;
`;

const Column = styled.View<{ showExternalLinkIcon?: boolean }>`
  flex-direction: column;
  align-items: flex-start;
  margin-left: 12px;
`;

const ChipCardItem = ({
  title,
  subTitle,
  label,
  LeftComponent,
  backgroundColor = undefined,
  onPress,
  testID,
  isWaitingAction,
  showExternalLinkIcon,
  additionalTitle,
}: ChipCardItemTypes) => {
  const accessibilityLabel = [label, title, additionalTitle, subTitle]
    .filter(Boolean)
    .join(', ');

  return (
    <ChipCardContainer
      accessibilityRole="button"
      accessible={true}
      accessibilityLabel={accessibilityLabel}
      importantForAccessibility="yes"
      backgroundColor={backgroundColor}
      onPress={onPress}
      {...testIdentifiers(testID as string)}>
      <Row>
        {LeftComponent && <LeftComponent />}
        <Column style={showExternalLinkIcon ? { width: 200 } : undefined}>
          {label && (
            <Meta
              accessible={false}
              color={theme.colors.gray300}
              testID={testID ? `${testID}-label` : undefined}>
              {label}
            </Meta>
          )}
          <Headline3
            accessible={false}
            numberOfLines={2}
            testID={testID ? `${testID}-title` : undefined}>
            {title}
          </Headline3>
          {additionalTitle && (
            <Headline3
              accessible={false}
              numberOfLines={2}
              testID={testID ? `${testID}-additionalTitle` : undefined}>
              {additionalTitle}
            </Headline3>
          )}
          {subTitle && (
            <Meta
              accessible={false}
              color={
                isWaitingAction ? theme.colors.aimoUiRed : theme.colors.gray300
              }
              testID={testID ? `${testID}-subtitle` : undefined}>
              {subTitle}
            </Meta>
          )}
        </Column>
        {showExternalLinkIcon && <Icon name="Open" size="m" />}
      </Row>
      {isWaitingAction && <RedBeacon translateY={-CARD_HEIGHT / 2 + 8} />}
    </ChipCardContainer>
  );
};

export default ChipCardItem;
